var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "loading-fade" } }, [
    _vm.showFlag
      ? _c(
          "div",
          { staticClass: "loading", class: _vm.isLocal ? "local" : "" },
          [
            _c("div", { staticClass: "bg" }),
            _vm._v(" "),
            _c("div", { staticClass: "cont-wrapper" }, [
              _c("div", { staticClass: "cont", class: _vm.type }, [
                _c("img", {
                  staticClass: "loadingIcon",
                  attrs: { src: require("./loading.gif") }
                }),
                _vm._v(" "),
                _c("p", { staticClass: "desc" }, [_vm._v(_vm._s(_vm.title))])
              ])
            ])
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6fd0764a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fd0764a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/base/page-loading/page-loading.vue
// module id = null
// module chunks = 